import { useState, useEffect } from 'react';

export const useCreditAnalysisCardLogic = (setCreditAnalysisData, totalIncome = 0) => {

  const [rendaProponentes, setRendaProponentes] = useState(totalIncome || '');
  const [valorFinanciado, setValorFinanciado] = useState('0');
  const [tipoSimulacaoCredito, setTipoSimulacaoCredito] = useState('1');
  const [fgtsValue, setFgtsValue] = useState('0');
  const [subsidyValue, setSubsidyValue] = useState('0');
  const [otherSubsidiesValue, setOtherSubsidiesValue] = useState('0');


  // Atualizar renda total quando totalIncome mudar
  useEffect(() => {
    if (totalIncome !== undefined) {
      setRendaProponentes(prevValue => {
        if (prevValue !== totalIncome) {
          return totalIncome;
        }
        return prevValue;
      });
    }
  }, [totalIncome]);

  // Atualizar dados do cartão quando os valores mudarem
  useEffect(() => {
    if (setCreditAnalysisData) {
      setCreditAnalysisData({
        tipoSimulacaoCredito,
        rendaProponentes,
        valorFinanciado,
        fgtsValue,
        subsidyValue,
        otherSubsidiesValue
      });
    }
  }, [
    tipoSimulacaoCredito,
    rendaProponentes,
    valorFinanciado,
    fgtsValue,
    subsidyValue,
    otherSubsidiesValue
  ]);

  const handleRendaProponentesChange = (e) => {
    setRendaProponentes(e.target.value);
  };

  const handleValorFinanciadoChange = (e) => {
    setValorFinanciado(e.target.value);
  };

  const handleTipoSimulacaoCreditoChange = (e) => {
    setTipoSimulacaoCredito(e.target.value);
  };

  const handleFgtsValueChange = (e) => {
    setFgtsValue(e.target.value);
  };

  const handleSubsidyValueChange = (e) => {
    setSubsidyValue(e.target.value);
  };

  const handleOtherSubsidiesValueChange = (e) => {
    setOtherSubsidiesValue(e.target.value);
  };

  return {
    rendaProponentes,
    valorFinanciado,
    tipoSimulacaoCredito,
    fgtsValue,
    subsidyValue,
    otherSubsidiesValue,
    handleRendaProponentesChange,
    handleValorFinanciadoChange,
    handleTipoSimulacaoCreditoChange,
    handleFgtsValueChange,
    handleSubsidyValueChange,
    handleOtherSubsidiesValueChange
  };
};